// Author LiangGangQiang
// Date 2021-08-25 13:58:14

class SithMesPrdPpHeaderInfoModifyType {
constructor({
        id = null,
        parentId = '',
        name = '',
        englishName = '',
        description = '',
        level = '',
        nodeCode = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.englishName = englishName;
    this.description = description;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpHeaderInfoModifyType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    parentIdFilter : "",
    parentNameFilter : "",
    nameFilter : "",
    englishNameFilter : "",
    descriptionFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentNameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.filter.parentName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeaderInfoModifyType'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpHeaderInfoModifyType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpHeaderInfoModifyType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
